<template>
    <div class="charts">
        <div class="tabs-container">
            <tile-tabs :tabsCount="3">
                <button @click="changeChart('count')" slot="slot1">Количество, шт.</button>
                <button @click="changeChart('sum')" slot="slot2">Сумма, млн. <i class="uk-icon-rub"></i></button>
                <button @click="changeChart('products')" slot="slot3">Виды услуг/продукции, %</button>
            </tile-tabs>
        </div>
        <div class="chart-container">
            <chart v-show="currentChart === 'count'" type="bar" :data="countChartData" :options="barOptions" />
            <chart v-show="currentChart === 'sum'" type="bar" :data="sumChartData" :options="barOptions" />
            <chart v-show="currentChart === 'products'" type="pie" :data="productsChartData" :options="pieOptions" />
        </div>
    </div>
</template>

<script>
import tileTabs from '@/components/ui/tileTabs/tileTabs.vue'
import chart from '@/components/ui/chart/chart.vue'

import { barOptions, pieOptions } from '@/components/card/tenders/chartOptions.js'
import { getPercent } from '@/helpers.ts'

export default {
    components: {
        tileTabs,
        chart
    },
    props: {
        stat: {
            type: Object,
            default: {}
        },
        years: {
            type: Array,
            default: []
        },
        type: {
            type: String,
            default: 'participants'
        },
        productsStat: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            currentChart: 'count',
            barOptions,
            pieOptions
        }
    },
    computed: {
        keys() {
            if(this.$props.type === 'participants') {
                return [['lots_win', 'lots_total'], ['sum_win', 'sum_total']]  
            } else {
                return [['lots_with_contr', 'lots_not_contr'], ['sum_with_contr', 'sum_not_contr']]
            }
        },
        countChartData() {
            return {
                labels: this.$props.years,
                datasets: [
                    {
                        label: this.$props.type === 'participants' ? 'Выиграл лотов' : 'Лотов с контрактом',
                        fill: false,
                        backgroundColor: this.$props.type === 'participants' ? "#2ecc71" : "#e74c3c",
                        borderColor: this.$props.type  === 'participants' ? "#2ecc71" : "#e74c3c",
                        borderWidth: 1,
                        data: this.$props.years.map(y => this.$props.stat?.[y]?.[this.keys[0][0]]),
                    },
                    {
                        label: this.$props.type === 'participants' ? 'Участвовал в лотах' : 'Лотов без контрактов',
                        fill: false,
                        backgroundColor: this.$props.type  === 'participants' ? "#76e0ac" : "#f1a29b",
                        borderColor: this.$props.type  === 'participants' ? "#76e0ac" : "#f1a29b",
                        borderWidth: 1,
                        data: this.$props.years.map(y => this.$props.stat?.[y]?.[this.keys[0][1]]),
                    }
                ]
            }
        },
        sumChartData() {
            return {
                labels: this.$props.years,
                datasets: [
                    {
                        label: this.$props.type === 'participants' ? 'Выиграл лотов' : 'Лотов с контрактом',
                        fill: false,
                        backgroundColor: this.$props.type === 'participants' ? "#2ecc71" : "#e74c3c",
                        borderColor: this.$props.type  === 'participants' ? "#2ecc71" : "#e74c3c",
                        borderWidth: 1,
                        data: this.$props.years.map(y => (this.$props.stat?.[y]?.[this.keys[1][0]] / 1000000).toFixed(2)),
                    },
                    {
                        label: this.$props.type === 'participants' ? 'Участвовал в лотах' : 'Лотов без контрактов',
                        fill: false,
                        backgroundColor: this.$props.type  === 'participants' ? "#76e0ac" : "#f1a29b",
                        borderColor: this.$props.type  === 'participants' ? "#76e0ac" : "#f1a29b",
                        borderWidth: 1,
                        data: this.$props.years.map(y => (this.$props.stat?.[y]?.[this.keys[1][1]] / 1000000).toFixed(2)),
                    }
                ]
            }
        },
        productsTotalAmount() {
            return this.$props.productsStat?.total?.reduce((total, el) => total += el.amount , 0)
        },
        othersAmount() { return this.$props.productsStat?.total?.slice(9).reduce((othersAmount, el ) => othersAmount += el.amount, 0) },
        productsChartLabels() {
            return [
                ...this.$props.productsStat?.total?.slice(0, 9).map(el => {
                    return `${(el.title && el.title !== 'unknown') ? el.title : 'Название не указано'}(${getPercent(el.amount, this.productsTotalAmount)}%)`
                }),
                `Прочие(${getPercent(this.othersAmount, this.productsTotalAmount)})`
            ]
        },
        productsChartAmount() {
            return [
                ...this.$props.productsStat?.total?.slice(0, 9).map(el => el.amount),
                this.othersAmount
            ]
        },
        productsChartData() { 
            return {  
                labels: this.productsChartLabels,
                datasets: [{
                    fill: false,
                    backgroundColor: [
                        "#bada55",
                        "#7fe5f0",
                        "#ff0000",
                        "#420420",
                        "#ffc0cb",
                        "#5ac18e",
                        "#ffd700",
                        "#c6e2ff",
                        "#4ca3dd",
                        "#696969"
                    ],
                    hoverOffset: 4,
                    data: this.productsChartAmount,
                }]
            }
        }
    },
    methods: {
        changeChart(chartType) {
           this.currentChart = chartType
        }
    }
}
</script>

<style lang="sass" scoped>
.charts
    .tabs-container
        width: 100%
        display: flex
        justify-content: flex-end
        margin: 5px 0
    .chart-container
        margin-bottom: 20px
</style>